module.exports = __webpack_public_path__ + "static/media/cor.876a2dff.jpeg";